var exports = {
  "oR": "Toast.module__toast___ZHp1T0",
  "Gv": "Toast.module__toastMobile___ZHp1T0",
  "qS": "Toast.module__toastDesktop___ZHp1T0",
  "Kk": "Toast.module__icon___ZHp1T0",
  "PO": "Toast.module__iconSuccess___ZHp1T0",
  "m5": "Toast.module__iconError___ZHp1T0",
  "oq": "Toast.module__iconMobile___ZHp1T0",
  "gB": "Toast.module__iconDesktop___ZHp1T0",
  "Qq": "Toast.module__text___ZHp1T0",
  "wV": "Toast.module__textMobile___ZHp1T0",
  "eL": "Toast.module__textDesktop___ZHp1T0",
};

module.exports = exports;
